import { Col } from 'antd';
import React from 'react';

import { GeneralInformation } from '../components/GeneralInformation';
import { OverViewRiskFactors, FooterButtons } from './components';
import { HeaderResult } from '../components/HeaderResult';
import { Comment } from '../components/Comment';
import { Resolution886ResultEnum } from '@/enums/Resolution886';

import * as S from './styles';

export function GeneralVersion(): JSX.Element {
	return (
		<S.DefaultResultContent>
			<HeaderResult title="Resolution 886" />
			<Col>
				<GeneralInformation />
			</Col>
			<Col style={{ marginTop: '24px' }}>
				<OverViewRiskFactors />
			</Col>
			<Col>
				<Comment result_type={Resolution886ResultEnum.GENERAL} />
			</Col>
			<Col>
				<FooterButtons />
			</Col>
		</S.DefaultResultContent>
	);
}
